import MasonryDescriptionContainer from "../../../../Components/Miscellaneous/Gallery/MasonryDescription/MasonryDescriptionContainer";

const MasonryDescription = () => {
  return <MasonryDescriptionContainer />
};

export default MasonryDescription;
